import { Box, Flex, styled } from '@driftt/dds'

export const StyledContainer = styled(Flex, {
  border: '1px solid $gray3',
  borderRadius: '$1',
  padding: '$2',
  marginTop: '$3',
})

export const StyledContent = styled(Box, {
  paddingTop: '$1',
  width: '100%',
})
